import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const SVG = styled.svg`
  .bottom {
    fill: ${(props) => (props.themeColor ? props.themeColor : 'rgba(85,188,189,1)')};
  }
`

const Shield = (props) => (
  <SVG className="shn-shield" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 72" themeColor={props.themeColor}>
    <g transform="translate(.162 .799)">
      <path
        className="top"
        d="M63.3250406,48.450804 C63.2590406,46.810804 63.2260406,22.910804 63.2260406,22.910804 C63.1270406,19.240804 62.4290406,16.660804 60.7400406,15.330804 C59.3460406,14.240804 36.2630406,1.240804 36.2630406,1.240804 C31.3000406,-1.479196 27.1830406,1.120804 27.1830406,1.120804 L7.77804062,12.660804 C3.81804062,15.140804 7.06804062,17.370804 7.06804062,17.370804 L12.1510406,21.150804 L29.9850406,10.440804 C30.8690406,9.750804 31.7550406,9.580804 32.5130406,9.640804 C33.7990406,9.710804 34.7410406,10.440804 34.7410406,10.440804 L51.2750406,21.140804 C53.6200406,22.980804 51.2750406,24.820804 51.2750406,24.820804 L48.4590406,26.780804 C46.1130406,28.620804 43.7670406,26.780804 43.7670406,26.780804 L31.8950406,19.580804 L24.7250406,24.310804 L59.6090406,51.060804 C61.0360406,52.090804 63.4250406,50.920804 63.3250406,48.450804"
      />
      <path
        className="bottom"
        d="M0.00304061551,22.510804 C0.0690406155,24.150804 0.102040616,48.060804 0.102040616,48.060804 C0.202040616,51.730804 0.899040616,54.310804 2.58904062,55.630804 C3.98304062,56.730804 27.0660406,69.720804 27.0660406,69.720804 C32.0280406,72.440804 36.1460406,69.840804 36.1460406,69.840804 L55.9640406,57.980804 C59.9210406,55.500804 56.6710406,53.270804 56.6710406,53.270804 L51.5910406,49.490804 L33.3420406,60.520804 C32.4600406,61.210804 31.5740406,61.390804 30.8160406,61.330804 C29.5290406,61.250804 28.5870406,60.520804 28.5870406,60.520804 L12.0540406,49.830804 C9.70804062,47.990804 12.0540406,46.150804 12.0540406,46.150804 L14.8690406,44.180804 C17.2150406,42.350804 19.5610406,44.180804 19.5610406,44.180804 L31.4330406,51.380804 L38.6040406,46.660804 L3.71904062,19.910804 C2.29304062,18.870804 -0.0969593845,20.040804 0.00304061551,22.510804"
      />
    </g>
  </SVG>
)

Shield.propTypes = {
  themeColor: PropTypes.string,
}
export default Shield



// WEBPACK FOOTER //
// ./src/images/icons/shgn/Shield.js